import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=252f6e22"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=252f6e22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports